<template>
  <div class="wrapper programPageWrap">
    <section class="schoolProgramHead">
      <div class="container">
        <div class="schoolProgramHeadInside">
          <div class="row">
            <div class="col-md-8">
              <h2>Secondary School Programs</h2>
            </div>
            <div class="col-md-4 grade-enroll" v-if="!isFetching">
              <div v-if="courseList.length > 0" class="purple-btn pointer" @click="goToCategory()">Enroll</div>
              <div class="purple-btn pointer" v-else-if="courseList.length == 0">Coming soon</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="schoolProgramWrap section-space">
      <div class="container">
        <div class="row">
          <div class="col-md-3" :class="{ 'active-class': !isFooterVisible }">
            <div class="gradesWrap" :class="{ scrolled: isScrolled, fixed: isFixed }">
              <!-- <div class="gradesCell" @click="courseList.length > 0 ? goToCategory() : null">Grade Pre 9</div> -->
              <div class="gradesCell" @click="courseList.length > 0 ? goToCategory() : null">Grade 9</div>
              <div class="gradesCell" @click="courseList.length > 0 ? goToCategory() : null">Grade 10</div>
              <!-- <div class="gradesCell" @click="courseList.length > 0 ? goToCategory() : null">0-level-O1</div>
              <div class="gradesCell" @click="courseList.length > 0 ? goToCategory() : null">0-level-O2</div>
              <div class="gradesCell" @click="courseList.length > 0 ? goToCategory() : null">0-level-O3</div> -->
            </div>
          </div>
          <div class="col-md-9 programDescCol">
            <div class="row" id="grade-pre-9">
              <div class="col-lg-6 order-lg-2">
                <div class="programImgWrap">
                  <img src="/assets/images/os-images/secondary-img1.png" width="499" height="293" alt="" />
                </div>
              </div>
              <div class="col-lg-6 order-lg-1">
                <div class="programDescWrap">
                  <!-- <h4>Grade Pre 9</h4>
                  <span>Age Group: <small class="blue-small-text">11–14 years </small> </span> -->
                  <h4>Program Description</h4>
                  <p>A structured curriculum designed to prepare students for board examinations and higher education. The program emphasizes conceptual clarity, problem-solving skills, and academic excellence, along with personal and social development.</p>
                  <h4>Program Features</h4>
                  <ul>
                    <li>Focused subject-specific learning with advanced courses in Mathematics, Science, English, and Social Studies.</li>
                    <li>Preparatory sessions for board examinations with past paper practice and exam strategies.</li>
                    <li>Co-curricular activities such as public speaking, essay writing, and leadership workshops.</li>
                    <li>Career awareness sessions to guide students toward their future academic and professional goals.</li>
                    <li>Progress tracking through regular assessments and detailed feedback reports.</li>
                  </ul>
                  <h4>Learning Formats</h4>
                  <p>Live classes and recorded sessions for flexibility in learning.</p>
                  <h4>Teaching Methodology</h4>
                  <p>Concept-driven and inquiry-based learning, emphasizing clarity and application of knowledge.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { classCourses as classCoursesStoreKeys } from "../store/keys";
export default {
  data() {
    return {
      isFetching: false,
      isFooterVisible: false,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getClassCourses();
    window.addEventListener("scroll", this.checkFooterInView);
    this.checkFooterInView();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.checkFooterInView);
  },
  computed: {
    ...mapGetters(classCoursesStoreKeys.namespace, classCoursesStoreKeys.getters),
  },
  methods: {
    ...mapActions(classCoursesStoreKeys.namespace, classCoursesStoreKeys.actions),
    getClassCourses() {
      this.isFetching = true;
      this.get_ClassCourses({
        data: {
          ProgramCategoryId: this.$decryptedRouteParams.id,
          PageNumber: 1,
          PageSize: 10,
        },
        config: {
          loader: {
            show: true,
          },
        },
      })
        .then((response) => {
          this.isFetching = false;
        })
        .catch((ex) => {
          this.isFetching = false;
          // this.$alertError(ex.message);
          console.log(ex.message);
        });
    },
    goToCategory() {
      this.$router.push({
        name: this.$route.params.routeName,
        params: { categoryId: this.$route.params.id },
      });
    },
    checkFooterInView() {
      const footer = document.querySelector(".site-footer");
      if (footer) {
        const rect = footer.getBoundingClientRect();
        this.isFooterVisible = rect.top >= window.innerHeight - 150;
      }
    },
  },
};
</script>
